export default __webpack_public_path__ + "static/media/password.5b0505b7.svg";